/* eslint-disable @typescript-eslint/naming-convention */
export var BalanceTransactionType;
(function (BalanceTransactionType) {
    BalanceTransactionType["payout"] = "payout";
    BalanceTransactionType["scheduled_payout"] = "scheduled_payout";
    BalanceTransactionType["payment"] = "payment";
    BalanceTransactionType["payment_refund"] = "payment_refund";
    BalanceTransactionType["issuing_authorization_hold"] = "issuing_authorization_hold";
    BalanceTransactionType["issuing_transaction"] = "issuing_transaction";
    BalanceTransactionType["issuing_dispute"] = "issuing_dispute";
    BalanceTransactionType["topup"] = "topup";
    BalanceTransactionType["pending_topup"] = "pending_topup";
})(BalanceTransactionType || (BalanceTransactionType = {}));
export var IssuingCardStatus;
(function (IssuingCardStatus) {
    IssuingCardStatus["Active"] = "Active";
    IssuingCardStatus["Inactive"] = "Inactive";
    IssuingCardStatus["Pending"] = "Pending";
    IssuingCardStatus["Canceled"] = "Canceled";
})(IssuingCardStatus || (IssuingCardStatus = {}));
export var CardHolderStatus;
(function (CardHolderStatus) {
    CardHolderStatus["Active"] = "Active";
    CardHolderStatus["Inactive"] = "Inactive";
    CardHolderStatus["Blocked"] = "Blocked";
})(CardHolderStatus || (CardHolderStatus = {}));
